import React from 'react';
import dayjs from 'dayjs';

import getConfiguration from '../../services/environment';
import Tab from '../../components/shared/tab/Tab';
import TabItem from '../../components/shared/tab/TabItem';
import { IGroup, IMeeting } from '../../store/group/groupState';
import MeetingList from './MeetingList';

import Spinner, { SpinnerSize } from '../../components/shared/spinner/Spinner'

interface IOwnProps {
    meetings: IMeeting[];
    group: IGroup | undefined;
    groupIdFallback: string;
    loading: boolean;
    isDi: boolean;
}

type Props = IOwnProps;

let emailDomain = 'dinet.di.dk';

class Meetings extends React.Component<Props, {}> {
    public async componentDidMount() {
        emailDomain = (await getConfiguration()).emailDomain;
    }

    public render() {
        if (this.props.loading && !this.props.meetings.length) {
            return <Spinner size={SpinnerSize.Large} />;
        }

        if (!this.props.meetings.length) {
            if (this.props.isDi) {
                const networkAddress = `${(this.props.group && this.props.group.alias) || this.props.groupIdFallback}@${emailDomain}`;

                return this.renderSection(<React.Fragment>
                    Ingen møder fundet. <br />
                    Opret et møde til gruppen ved at sende en Outlook møde invitation til <a className="link" href={`mailto:${networkAddress}`}>{networkAddress}</a>
                </React.Fragment>);
            } else {
                return null;
            }
        }

        return this.renderSection(this.tabs());
    }

    private renderSection = (children: React.ReactNode) => <section className="section">
        <div className="deck">
            <div className="w--md banner-title">
                <h1>
                    {this.props.group && this.props.group.id.substring(0, 2) === 'ar'
                        ? 'Moduler'
                        : 'Møder'}
                    </h1>
            </div>
        </div>
        <div className="deck">
            <div className="w--md">
                {children}
            </div>
        </div>
    </section>;

    private tabs() {
        const upcoming = this.props.meetings.filter(m => dayjs(m.startTime).endOf('day').isAfter(dayjs()));
        const expired = this.props.meetings.filter(m => !dayjs(m.startTime).endOf('day').isAfter(dayjs()));
        const reactNodes: JSX.Element[] = [];

        if (upcoming.length) {
            reactNodes.push(this.tab('Kommende', upcoming));
        }

        if (expired.length) {
            reactNodes.push(this.tab('Tidligere', expired));
        }

        return <Tab>{reactNodes}</Tab>;
    }

    private tab(name: string, meetings: IMeeting[]) {
        return <TabItem header={name} key={name}>
            <MeetingList group={this.props.group} meetings={meetings} />
        </TabItem>;
    }
}

export default Meetings;